// @flow
import * as React from 'react'
import styled from 'styled-components'

import FlexBox from './Flexbox'
import colors from '../styles/colors'

const Heading = ({ title, children, border = true }) => (
  <Wrapper border={border}>
    <StyledH1>{title}</StyledH1>
    <FlexBox align="center" justify="space-between">
      {children}
    </FlexBox>
  </Wrapper>
)

const Wrapper = styled.div`
  background: #eaeaea;
  display: flex;
  align-items: center;
  min-height: 80px;
  border-bottom: ${(props) =>
    props.border ? `1px solid ${colors.alabaster}` : `none`};
`

const StyledH1 = styled.h1`
  flex: 1;
  margin: 0;
  font-weight: normal;
  font-size: 1.62671rem;
`

export default Heading
